module.exports = __webpack_public_path__ + "img/solutionIMG.c9984bb9.png";